import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Row,
  Col
} from 'reactstrap';
import CountryDropdown from '../../shared/CountryDropdown';
import StateDropdown from '../../shared/StateDropdown';
import TimeZonesDropdown from  '../../shared/TimeZonesDropdown';
import InfoInputField from '../../shared/LabeledTextInput';
import InfoField from '../../shared/InfoField';
import { validatePhone } from '../../../utils/validators';


export default class ProfileInfo extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  static get propTypes () {
    return {
      editMode: PropTypes.bool,
      profile: PropTypes.object,
      errors: PropTypes.object,
      onFieldChange: PropTypes.func,
      onFieldValidate: PropTypes.func,
      showErrors: PropTypes.bool
    };
  }

  static get defaultProps () {
    return {
      profile: {},
    };
  }

  render () {
    const {
      editMode,
      profile,
      errors,
      onFieldChange,
      onFieldValidate,
      showErrors
    } = this.props;
    return (
      <Container fluid className='px-0 text-left'>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label={`First Name ${editMode ? '*' : ''}`}
              value={profile.firstName}
              error={errors.firstName}
              invalid={(showErrors || profile.firstName) && errors.firstName}
              allowBlank={false}
              minLength={1}
              maxLength={20}
              onChange={value => onFieldChange('firstName', value)}
              onValidate={value => onFieldValidate('firstName', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label={`Last Name ${editMode ? '*' : ''}`}
              value={profile.lastName}
              error={errors.lastName}
              invalid={(showErrors || profile.lastName) && errors.lastName}
              allowBlank={false}
              minLength={1}
              maxLength={20}
              onChange={value => onFieldChange('lastName', value)}
              onValidate={value => onFieldValidate('lastName', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Phone'
              value={profile.phone}
              error={errors.phone}
              invalid={errors.phone}
              validator={validatePhone}
              validationError='Invalid phone/fax format'
              onChange={value => onFieldChange('phone', value)}
              onValidate={value => onFieldValidate('phone', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Fax'
              value={profile.fax}
              error={errors.fax}
              invalid={errors.fax}
              validator={validatePhone}
              validationError='Invalid phone/fax format'
              onChange={value => onFieldChange('fax', value)}
              onValidate={value => onFieldValidate('fax', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Address 1'
              value={profile.address1}
              error={errors.address1}
              invalid={errors.address1}
              maxLength={100}
              onChange={value => onFieldChange('address1', value)}
              onValidate={value => onFieldValidate('address1', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='City'
              value={profile.city}
              error={errors.city}
              invalid={errors.city}
              maxLength={50}
              onChange={value => onFieldChange('city', value)}
              onValidate={value => onFieldValidate('city', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Address 2'
              value={profile.address2}
              error={errors.address2}
              invalid={errors.address2}
              maxLength={100}
              onChange={value => onFieldChange('address2', value)}
              onValidate={value => onFieldValidate('address2', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoField editMode={editMode} label='State/Province' value={profile.state}>
              <StateDropdown
                country={profile.country}
                value={profile.state}
                onChange={value => onFieldChange('state', value)}
              />
            </InfoField>
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Postal Code'
              value={profile.postalCode}
              error={errors.postalCode}
              invalid={errors.postalCode}
              minLength={2}
              maxLength={12}
              onChange={value => onFieldChange('postalCode', value)}
              onValidate={value => onFieldValidate('postalCode', value)}
            />
          </Col>
          <Col md={6} className='mb-3'>
            <InfoField editMode={editMode} label='Country' value={profile.coutry}>
              <CountryDropdown
                value={profile.country}
                onChange={(value) => onFieldChange('country', value)}
              />
            </InfoField>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <InfoField editMode={editMode} label="Time Zone" value={profile.timeZoneId}>
              <TimeZonesDropdown
                value={profile.timeZoneId}
                onChange={value => onFieldChange('timeZoneId', value)}
              />
            </InfoField>
          </Col>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='County'
              value={profile.county}
              error={errors.county}
              invalid={errors.county}
              maxLength={50}
              onChange={value => onFieldChange('county', value)}
              onValidate={value => onFieldValidate('county', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <InfoInputField
              editMode={editMode}
              label="State Certification"
              value={profile.stateCertification}
              error={errors.stateCertification}
              invalid={errors.stateCertification}
              maxLength={50}
              onChange={value => onFieldChange('stateCertification', value)}
              onValidate={value => onFieldValidate('stateCertification', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3'>
            <InfoInputField
              editMode={editMode}
              label='Licenses'
              value={profile.license1}
              error={errors.license1}
              invalid={errors.license1}
              maxLength={50}
              onChange={value => onFieldChange('license1', value)}
              onValidate={value => onFieldValidate('license1', value)}
            />
          </Col>
          <Col md={6} className='mb-3 pt-2'>
            <InfoInputField
              editMode={editMode}
              value={profile.license2}
              error={errors.license2}
              invalid={errors.license2}
              maxLength={50}
              onChange={value => onFieldChange('license2', value)}
              onValidate={value => onFieldValidate('license2', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3 pt-2'>
            <InfoInputField
              editMode={editMode}
              value={profile.license3}
              error={errors.license3}
              invalid={errors.license3}
              maxLength={50}
              onChange={value => onFieldChange('license3', value)}
              onValidate={value => onFieldValidate('license3', value)}
            />
          </Col>
          <Col md={6} className='mb-3 pt-2'>
            <InfoInputField
              editMode={editMode}
              value={profile.license4}
              error={errors.license4}
              invalid={errors.license4}
              maxLength={50}
              onChange={value => onFieldChange('license4', value)}
              onValidate={value => onFieldValidate('license4', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className='mb-3 pt-2'>
            <InfoInputField
              editMode={editMode}
              value={profile.license5}
              error={errors.license5}
              invalid={errors.license5}
              maxLength={50}
              onChange={value => onFieldChange('license5', value)}
              onValidate={value => onFieldValidate('license5', value)}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/components/profile/ProfileInfo/index.jsx